export default {
    combinedFuturesChart: {
        title: 'Fig C · Kombinirana futures pozicija (BASE + PEAK + OFF_PEAK)',
        subtitle: 'Referenca — skupno zloženo po intervalu',
        ariaLabel:
            'Grafikon zloženih površin: BASE spodnja plast 1 MW ravno, PEAK 2.5 MW zloženo med 08:00–20:00, OFF_PEAK 0.8 MW zloženo med boki. Skupno = kombinirana futures prilagoditev na interval.',
        baseLabel: 'BASE ({mw} MW)',
        peakLabel: 'PEAK ({mw} MW · 08:00–20:00)',
        offPeakLabel: 'OFF_PEAK ({mw} MW · boki)',
    },
}
